import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';

export default {
  title: 'New Room config Info Mass Update (only filled fields will be updated)',
  attributeName: 'sportRoomConfigInfo',
  fields: [
    {
      attributeName: 'sportRoom',
      helpText: 'Room',
      type: FormInputTypes.SELECT,
      label: 'Room',
      placeholder: 'Please enter to select a Room',
      multiple: false,
      url: 'liveSportRoomslist',
      emptyValue:true,
      childField:'config',
      default:'(Empty)', //default value to empty option
      fieldValue:'id',
      fieldName:'name',
      asyncSelect: true,
      options:[]
    },
    {
      attributeName: 'config',
      helpText: 'Select a valid config for the app selected, or set All for all the possible configs of the app',
      type: FormInputTypes.SELECT,
      label: 'Config',
      placeholder: 'Please enter to add a valid config',
      multiple: false,
      url: 'liveConfigslist',
      parentField:'sportRoom',
      enabledWhen:{"field":"sportRoom","notValues":['(Empty)']},
      emptyValue:true,
      default:'(Empty)', //default value to empty option
      allValue:'(All)',
      fieldValue:'id',
      fieldName:'name',
      asyncSelect: true,
      options:[]
    },
    {
      attributeName:"sep1",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'composeExperienceUrl',
      helpText: 'Select a valid media Url',
      type: FormInputTypes.SELECT,
      label: 'Media Url',
      placeholder: 'Please add a valid media url',
      multiple: false,
      url: 'liveComposeExperienceList',
      emptyValue:true,
      default:'(Empty)', //default value to empty option
      fieldValue:'id',
      fieldName:'url',
      asyncSelect: true,
      pageId:true,
      options:[]
    },
    // {
    //   attributeName: 'duration',
    //   type: FormInputTypes.TEXT_INPUT.TEXT,
    //   label: 'Duration',
    //   placeholder: 'Video duration...',
    //   helpText: 'Duration of the video in the format mm:ss.',
    // },
    {
      attributeName:"sep2",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'visibility',
      label: 'Visibility',
      helpText: 'Visibility of the video in the panel its listed.',
      default: '(Empty)',
      emptyValue:true,
      type: FormInputTypes.SELECT,
      options: [
        { name: 'Enabled', value: 'enabled' },
        { name: 'Hidden', value: 'hidden' },
      ],
    },
    {
      attributeName: 'activationEpoch',
      label: 'Activation Time',
      helpText: 'Date of the activation event for this video in clients.',
      type: FormInputTypes.DATE_TIME,
    },
    {
      attributeName: 'startEpoch',
      label: 'Starting Time',
      helpText: 'Date of the starting event countdown.',
      type: FormInputTypes.DATE_TIME,
    },
    {
      attributeName: 'isLiveContinuous',
      label: 'Remove Progress Indicator',
      helpText: 'Selecting this field hides the current progress indicator from the player bar, making it invisible to the end user. This option should remain checked for 24/7 live streams.',
      default: '(Empty)',
      emptyValue:true,
      type: FormInputTypes.SELECT,
      options: [
        { name: 'Yes', value: 'yes' },
        { name: 'No', value: 'no' },
      ],
    },
    {
      attributeName: 'isLiveChannel',
      label: 'Is Live Channel',
      helpText: 'Selecting this field hides the current content is marked as Live Channel to be assigned the corresponding tag.',
      default: '(Empty)',
      emptyValue:true,
      type: FormInputTypes.SELECT,
      options: [
        { name: 'Yes', value: 'yes' },
        { name: 'No', value: 'no' },
      ],
    },
    {
      attributeName: 'liveStatus',
      label: 'Stream Status',
      helpText: 'Check the status of a live event (STOPPED, ONGOING, ENDED).',
      default: 'stopped',
      type: FormInputTypes.SELECT,
      default: '(Empty)',
      emptyValue:true,
      options: [
        { name: 'Offline', value: 'offline' },
        { name: 'Live Ongoing', value: 'ongoing' },
        { name: 'Live Ended', value: 'ended' },
      ],
    },
    {
      attributeName:"sep4",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'playerVersion',
      label: 'Player version',
      helpText: 'Player version of the video.',
      default: '(Empty)',
      emptyValue:true,
      type: FormInputTypes.SELECT,
      options: [
        { name: 'YBVR', value:'YBVR' },
        { name: 'AVPRO', value: 'AVPRO' },
      ],
    },
    {
      attributeName: 'geometry',
      label: 'Geometry',
      helpText: 'Signaling version of the video.',
      default: '(Empty)',
      emptyValue:true,
      type: FormInputTypes.SELECT,
      options: [
        { name: 'Autodetect', value: 'v2' },
        { name: 'Equirectangular', value: 'equirectangular' },
        { name: 'Equidome', value: 'equidome' },
        { name: 'Flat', value: 'flat' },
      ],
    },
    {
      attributeName: 'type',
      label: 'Type',
      default: '(Empty)',
      emptyValue:true,
      type: FormInputTypes.SELECT,
      helpText: 'Whether the video is mono or stereo.',
      options: [
        { name: 'Mono', value: 'mono' },
        { name: 'Stereo', value: 'stereo' },
        { name: 'Stereo LR', value: 'stereolr' },
      ],
      visibleWhen:[{"field":"geometry","notValue":"v2"}]

    },
    {
      attributeName: 'isAudioRecordingAllowed',
      label: 'Allow Audio feedback ',
      helpText: 'Specifies if the content allow audio feedback.',
      default: '(Empty)',
      emptyValue:true,
      type: FormInputTypes.SELECT,
      options: [
        { name: 'Yes', value: 'yes' },
        { name: 'No', value: 'no' },
      ],
    },
    {
      attributeName: 'isSlowMotionAllowed',
      label: 'Allow Slow motion ',
      helpText: 'Specifies if the content allow slow motion.',
      default: '(Empty)',
      emptyValue:true,
      type: FormInputTypes.SELECT,
      options: [
        { name: 'Yes', value: 'yes' },
        { name: 'No', value: 'no' },
      ],
    },
    {
      attributeName: 'isTimeShiftingAllowed',
      label: 'Allow Timeshift ',
      helpText: 'Specifies if the content allow slow motion.',
      default: '(Empty)',
      emptyValue:true,
      type: FormInputTypes.SELECT,
      options: [
        { name: 'Yes', value: 'yes' },
        { name: 'No', value: 'no' },
      ],
    },
    {
      attributeName:"sep5",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'poster',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Poster',
      helpText: 'Any valid url to a PNG poster image file.',
      placeholder: 'Video poster URL...',
      fileType: ['image/*'],
      hasSelect:false,

    },
    {
      attributeName: 'largePoster',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Large Poster',
      helpText: 'Any valid url to a PNG poster image file to use inside a side panel.',
      placeholder: 'Video large poster URL...',
      fileType: ['image/*'],
      hasSelect:false,

    },
    {
      attributeName: 'descriptionPoster',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Description Poster',
      helpText: 'URL to the poster image file that will be show in the description panel.',
      placeholder: 'Video description poster URL...',
      fileType: ['image/*'],
      hasSelect:false,

    },
    {
      attributeName: 'xxl',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'XXL Poster',
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
      hasSelect:false,

    },
    {
      attributeName: 'xlVertical',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'XL Vertical Poster',
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
      hasSelect:false,

    },
    {
      attributeName: 'xlHorizontal',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'XL Horizontal Poster',
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
      hasSelect:false,

    },
    {
      attributeName: 'lVertical',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'L Vertical Poster',
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
      hasSelect:false,

    },
    {
      attributeName: 'lHorizontal',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'L Horizontal Poster',
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
      hasSelect:false,

    },
    {
      attributeName: 'm',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'M Poster',
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
      hasSelect:false,

    },
    {
      attributeName: 'sVertical',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'S Vertical Poster',
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
      hasSelect:false,

    },
    {
      attributeName: 'sHorizontal',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'S Horizontal Poster',
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
      hasSelect:false,

    },
    {
      attributeName: 'xs',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'XS Poster',
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
      hasSelect:false,

    },
    {
      attributeName: 'backgroundFlat',
      type: FormInputTypes.BACKGROUND,
      label: 'Background Flat',
      helpText: 'Background to use in the flat video geometries.',
      fileType: ['image/*'],
      hasSelect:false,

    },
    {
      attributeName: 'background180',
      type: FormInputTypes.BACKGROUND,
      label: 'Background 180',
      helpText: 'Background to use in the 180 video geometries.',
      fileType: ['image/*'],
      hasSelect:false,

    },
    {
      attributeName: 'producers',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Producers',
      placeholder: 'Video producers...',
      helpText: 'Producers of the video.',
    },
    {
      attributeName: 'tags',
      helpText: 'List of tags',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Tags',
      multiple:true,
      placeholder: 'Press enter to add a tag...',
    },
    {
      attributeName: 'description',
      type: FormInputTypes.TEXT_EDITOR,
      label: 'Description',
      placeholder: 'Video description...',
      helpText: 'Description of the video.',
    },
    {
      attributeName: 'isHighQuality',
      label: 'Is High Quality',
      helpText: 'Whether the video is in 8K quality.',
      default: '(Empty)',
      emptyValue:true,
      type: FormInputTypes.SELECT,
      options: [
        { name: 'Yes', value: 'yes' },
        { name: 'No', value: 'no' },
      ],
    },
    // {
    //   attributeName: 'expirationEpoch',
    //   label: 'Expiration Time',
    //   helpText: 'Date of the expiration event for this video.',
    //   type: FormInputTypes.DATE_TIME,
    // },
  ],
};
